import styled from "styled-components";
import backgroundImage from "../../../shared/static/background.png";

export const Background = styled.div`
  width: 100vw;
  min-height: calc(100vh - 64px);
  background-image: url(${backgroundImage});
  background-size: cover;
`;
